import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container relative hidden h-[100vh] flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex\"><div class=\"absolute inset-0 signin-bg\"></div><div class=\"relative z-20 flex items-center text-lg font-medium\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"mr-2 h-6 w-6\"><path d=\"M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3\"></path></svg> Acme Inc </div><div class=\"relative z-20 mt-auto\"><blockquote class=\"space-y-2\"><p class=\"text-lg\"> “Salvaguardia su Misura: Proteggi il Tetto, Preserva il Futuro”<br><br> Questo slogan mette in luce l&#39;importanza della personalizzazione del servizio, la protezione dell&#39;edificio e la visione a lungo termine, tutti elementi chiave per la manutenzione dei tetti. </p></blockquote></div></div>", 1)
const _hoisted_3 = { class: "lg:p-8" }
const _hoisted_4 = { class: "mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]" }
const _hoisted_5 = { class: "flex flex-col space-y-2 text-center" }
const _hoisted_6 = { class: "text-2xl font-semibold tracking-tight" }
const _hoisted_7 = { class: "text-sm text-muted-foreground" }

import ResetPasswordForm from "@/components/signin/ResetPasswordForm.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPasswordView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('login.reset_password')), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('login.reset_subtitle')), 1)
        ]),
        _createVNode(ResetPasswordForm)
      ])
    ])
  ]))
}
}

})